import React from 'react'


const OneCartItem = (props) => {
    return (
        <div className='cartitem__container'>
            <div className="cartitem__image">
                <img src={props.img} alt="img" className='cartitem__imagesize' />
            </div>

            <div className="cartitem__name">
                {props.name}
            </div>

            <div className="cartitem__price">
                {props.originalPrice && <span className="cartitem__originalprice">{props.originalPrice}</span>}
                {props.price}
            </div>
        </div>
    )
}

export default OneCartItem